//@ts-nocheck
import './utilities/sentry';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './fonts/Jost-Regular.ttf';
import './fonts/Jost-Light.ttf';
import './fonts/Jost-Bold.ttf';
import './fonts/Jost-ExtraBold.ttf';
import store from './redux/Store';
import App from './App';
import whyDidYouRender from '@welldone-software/why-did-you-render';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);
